/* Source: /home/ubuntu/libredraw/frontend/editor/PageBar.cl.jac */
import {__jacJsx, __jacSpawn} from "@jac/runtime";
import { Plus, Undo2, Redo2, Keyboard, CircleHelp, MoreHorizontal, Copy, Trash2, Pencil } from "lucide-react";
import { cn } from "../../lib/utils.js";
import { useState } from "@jac/runtime";
function Icon_btn(props) {
  const {title, icon, onClick} = props;
  return __jacJsx("button", {"title": title, "onClick": onClick, "className": "flex size-7 items-center justify-center rounded-md text-muted-foreground hover:bg-accent hover:text-foreground"}, [icon]);
}
const icon_btn = Icon_btn;
function PageBar(props) {
  const {pages: pages = [], activePageId: activePageId = "", onSwitch: onSwitch = null, onAdd: onAdd = null, onRename: onRename = null, onDuplicate: onDuplicate = null, onDelete: onDelete = null, onReorder: onReorder = null, onUndo: onUndo = null, onRedo: onRedo = null, onShortcuts: onShortcuts = null} = props;
  const [menuFor, setMenuFor] = useState("");
  const [editingId, setEditingId] = useState("");
  const [draftName, setDraftName] = useState("");
  const [dragId, setDragId] = useState("");
  function drop_on(targetId) {
    if (((dragId === "") || (dragId === targetId))) {
      setDragId("");
      return;
    }
    let order = [];
    for (const pg of pages) {
      let pid = pg["id"];
      if ((pid === dragId)) {
        continue;
      }
      if ((pid === targetId)) {
        order = [...order, ...[dragId]];
      }
      order = [...order, ...[pid]];
    }
    if (onReorder) {
      onReorder(order);
    }
    setDragId("");
  }
  function start_rename(pid, name) {
    setEditingId(pid);
    setDraftName(name);
    setMenuFor("");
  }
  function commit_rename() {
    if ((((editingId !== "") && (draftName !== "")) && onRename)) {
      onRename(editingId, draftName);
    }
    setEditingId("");
  }
  return __jacJsx("footer", {"className": "z-10 flex h-10 shrink-0 items-center justify-between border-t border-border bg-card px-2.5"}, [__jacJsx("div", {"className": "flex items-center gap-1"}, [__jacJsx("span", {"className": "px-1 text-xs font-medium text-muted-foreground"}, ["Pages"]), pages.map(pg => __jacJsx("div", {"key": pg["id"], "className": "relative flex items-center"}, [((editingId === pg["id"]) ? __jacJsx("input", {"autoFocus": true, "value": draftName, "onChange": e => {
    setDraftName(e.target.value);
  }, "onBlur": _e => {
    commit_rename();
  }, "onKeyDown": e => {
    if ((e.key === "Enter")) {
      commit_rename();
    } else if ((e.key === "Escape")) {
      setEditingId("");
    }
  }, "className": "h-7 w-28 rounded-md border border-primary bg-background px-2 text-sm outline-none"}, []) : __jacJsx("div", {"draggable": true, "onDragStart": _e => {
    setDragId(pg["id"]);
  }, "onDragOver": e => {
    e.preventDefault();
  }, "onDrop": _e => {
    drop_on(pg["id"]);
  }, "className": cn("flex cursor-grab items-center rounded-md transition-colors active:cursor-grabbing", ((pg["id"] === activePageId) ? "bg-primary-soft text-primary" : "text-muted-foreground hover:bg-accent hover:text-foreground"), ((dragId === pg["id"]) ? "opacity-50" : ""))}, [__jacJsx("button", {"onClick": _e => {
    if (onSwitch) {
      onSwitch(pg["id"]);
    }
  }, "onDoubleClick": _e => {
    start_rename(pg["id"], pg["name"]);
  }, "className": cn("px-3 py-1 text-sm", ((pg["id"] === activePageId) ? "font-medium" : ""))}, [pg["name"]]), __jacJsx("button", {"title": "Page options", "onClick": _e => {
    setMenuFor(((menuFor === pg["id"]) ? "" : pg["id"]));
  }, "className": "flex size-6 items-center justify-center rounded-md hover:bg-black/5"}, [__jacJsx(MoreHorizontal, {"size": 14}, [])])])), ((menuFor === pg["id"]) ? __jacJsx("div", {"className": "absolute bottom-full left-0 z-30 mb-1 w-40 overflow-hidden rounded-lg border border-border bg-card py-1 shadow-pop"}, [__jacJsx("button", {"onClick": _e => {
    start_rename(pg["id"], pg["name"]);
  }, "className": "flex w-full items-center gap-2 px-3 py-1.5 text-left text-sm hover:bg-accent"}, [__jacJsx(Pencil, {"size": 14}, []), " Rename"]), __jacJsx("button", {"onClick": _e => {
    setMenuFor("");
    if (onDuplicate) {
      onDuplicate(pg["id"]);
    }
  }, "className": "flex w-full items-center gap-2 px-3 py-1.5 text-left text-sm hover:bg-accent"}, [__jacJsx(Copy, {"size": 14}, []), " Duplicate"]), __jacJsx("button", {"onClick": _e => {
    setMenuFor("");
    if (onDelete) {
      onDelete(pg["id"]);
    }
  }, "className": "flex w-full items-center gap-2 px-3 py-1.5 text-left text-sm text-destructive hover:bg-destructive/10"}, [__jacJsx(Trash2, {"size": 14}, []), " Delete"])]) : null)])), __jacJsx("button", {"title": "Add page", "onClick": onAdd, "className": "ml-0.5 flex size-7 items-center justify-center rounded-md text-muted-foreground hover:bg-accent hover:text-foreground"}, [__jacJsx(Plus, {"size": 16}, [])])]), __jacJsx("div", {"className": "flex items-center gap-1"}, [icon_btn({title: "Undo  \u2318Z", icon: __jacJsx(Undo2, {"size": 16}, []), onClick: onUndo}), icon_btn({title: "Redo  \u2318\u21e7Z", icon: __jacJsx(Redo2, {"size": 16}, []), onClick: onRedo}), __jacJsx("div", {"className": "mx-1 h-5 w-px bg-border"}, []), icon_btn({title: "Keyboard shortcuts", icon: __jacJsx(Keyboard, {"size": 16}, []), onClick: onShortcuts}), icon_btn({title: "Help & shortcuts", icon: __jacJsx(CircleHelp, {"size": 16}, []), onClick: onShortcuts})]), ((menuFor !== "") ? __jacJsx("div", {"className": "fixed inset-0 z-20", "onClick": _e => {
    setMenuFor("");
  }}, []) : null)]);
}
/*jac:refresh-boundary*/;
export {PageBar};
//# sourceMappingURL=PageBar.js.map
